import React, { useState, useEffect } from 'react'
import { get } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import { List } from 'shared/components'
import { sendErrorReport, displayValue } from 'shared/helpers'
import { fetchUserGroups } from 'src/LicenseManager/actions'

export default function UserGroups({ filterByCustomerAccount }) {
  const { managerId, companyId } = useParams()
  const history = useHistory()
  const [list, setList] = useState([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)

  const updateGroups = page => {
    setLoading(true)
    fetchUserGroups(companyId, managerId, filterByCustomerAccount, page)
      .then(res => {
        setList(get(res, 'data'))
        setLoading(false)
      })
      .catch(err => {
        sendErrorReport(err, 'Cannot get customer licenses')
        setLoading(false)
      })
  }

  useEffect(() => {
    updateGroups(page)
  }, [page, filterByCustomerAccount])

  const handleUserPageChange = page => {
    setPage(page)
    updateGroups(page)
  }

  const redirectToUserGroupPage = rowData => {
    const userGroupID = get(rowData, 'original.id')
    history.push(`/${companyId}/license_users/user_groups/${userGroupID}`)
  }

  return (
    <List
      clickable
      data={get(list, 'results') || []}
      loading={loading}
      manual
      page={page}
      pages={Math.ceil(get(list, 'count') / 20)}
      minRows={2}
      showPagination
      onPageChange={handleUserPageChange}
      handleClick={rowData => redirectToUserGroupPage(rowData)}
      columns={[
        {
          accessor: 'name',
          Header: __('Name'),
          Cell: cellInfo => displayValue(cellInfo.value)
        },
        {
          accessor: 'code',
          Header: __('Code'),
          Cell: cellInfo => displayValue(cellInfo.value)
        },
        {
          accessor: 'description',
          Header: __('Description'),
          Cell: cellInfo => displayValue(cellInfo.value)
        },
        {
          accessor: 'metadata',
          Header: __('Metadata'),
          Cell: cellInfo => displayValue(JSON.stringify(cellInfo.value))
        }
      ]}
    />
  )
}
